import { FC, HTMLAttributes } from "react";

import { Typography } from "../../components/core/Typography/Typography";
import { TypographyVariant } from "../../constants/typography";
import AppBar from "../../components/common/AppBar/AppBar";
import { Icon } from "../../components/core/Icon/Icon";
import { HistoryGaming } from "../../models/historyGaming";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useStyles } from "./Subsciption.style";


const Subscription: FC<HTMLAttributes<HTMLDivElement>> = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <AppBar
                leftItems={
                    <Icon
                        name="icon-bold-arrow-left-3"
                        onClick={() => HistoryGaming.back(navigate)}
                    />
                }
                centerItems={
                    <Typography variant={TypographyVariant.BodyB4Medium}>
                        {t("common_Subscription")}
                    </Typography>
                }
            />
        </div>
    )

};

export default Subscription;